import cloneDeep from 'lodash.clonedeep';

const initialState = {
  step1: {
    startDate: null,
    state: null,
    eligibility: null,
    dvaCard: false,
    name: null,
    DOB: '',
    gender: null,
  },
  step2: {
    composition: null,
    partnerDOB: '',
    myCircumstances: null,
    rebateTier: null,
    numberOfChildren: null,
    familyPlus: null,
    coverType: null,
    reviewCover: null,
  },
  step3: {
    coverReason: null,
    specificTreatmentCategory: [],
    specificTreatmentModality: [],
    noPregnancy: true,
  },
  closedProducts: {
    hospital: null,
    extras: null,
  },
  recommendedProducts: null,
  paymentFrequency: null,
  selectedProducts: null,
  selectedExcess: null,
  isFromEmailQuote: false,
};

export default {
  namespaced: true,

  initialState,

  state: cloneDeep(initialState),

  mutations: {
    updateMyDetails(state, data) {
      state.step1 = data;
    },
    updateMyCover(state, data) {
      state.step2 = data;
    },
    updateMyNeeds(state, data) {
      state.step3 = data;
    },
    updateClosedHospitalProduct(state, data) {
      state.closedProducts.hospital = data;
    },
    updateClosedExtrasProduct(state, data) {
      state.closedProducts.extras = data;
    },
    updateRecommendedProducts(state, data) {
      state.recommendedProducts = data;
    },
    updatePaymentFrequency(state, data) {
      state.paymentFrequency = data;
    },
    resetMyNeeds(state) {
      state.step3 = cloneDeep(initialState.step3);
    },
    updateSelectedProducts(state, data) {
      state.selectedProducts = data;
    },
    updateSelectedExcess(state, data) {
      state.selectedExcess = data;
    },
    updateIsFromEmailQuote(state, data) {
      state.isFromEmailQuote = data;
    },
    resetChangeCoverData(state) {
      Object.assign(state, cloneDeep(initialState));
    },
  },

  getters: {
    getChangeCover: (state) => {
      return state;
    },
    getMyDetails: (state) => {
      return state.step1;
    },
    getMyCover: (state) => {
      return state.step2;
    },
    getMyNeeds: (state) => {
      return state.step3;
    },
    getClosedHospitalProduct: (state) => {
      return state.closedProducts.hospital;
    },
    getClosedExtrasProduct: (state) => {
      return state.closedProducts.extras;
    },
    getRecommendedProducts: (state) => {
      return state.recommendedProducts;
    },
    getPaymentFrequency: (state) => {
      return state.paymentFrequency;
    },
    getSelectedProducts: (state) => {
      return state.selectedProducts;
    },
    getSelectedExcess: (state) => {
      return state.selectedExcess;
    },
    getIsFromEmailQuote: (state) => {
      return state.isFromEmailQuote;
    },
  },
};
